import { render, staticRenderFns } from "./InfoBox.vue?vue&type=template&id=8d9eb75c&scoped=true&"
import script from "./InfoBox.vue?vue&type=script&lang=ts&"
export * from "./InfoBox.vue?vue&type=script&lang=ts&"
import style0 from "./InfoBox.vue?vue&type=style&index=0&id=8d9eb75c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d9eb75c",
  null
  
)

export default component.exports